import React, {Component} from 'react'
import {duration, ease} from '../config'
import {findDOMNode} from 'react-dom'
import {ButtonCircle} from 'rebass'
import {style, media, merge} from 'glamor'
import * as colors from '../colors'
import api from '../api'
import {Arrow} from 'reline'
let i = 0
import Panel from './Panel'
import {TimelineMax, TweenMax} from 'gsap'
import Logo from './Logo'
import Label from './Label'
import Thumb from './ThumbProject'
import Project from './pages/Project'
import {Link, Match} from 'react-router'
import find from 'lodash.find'
import ProjectList from './ProjectList'


export default class Category extends Component {

  constructor(props){
    super(props)
    this.state = {
      direction: 1
    }
  }

  componentDidMount(){
    window.scrollTo(0, 0)
  }

  componentWillReceiveProps(newProps){
    if(newProps.location.pathname !== this.props.location.pathname){
      let direction = -1
      if(newProps.location.pathname.indexOf(this.props.location.pathname) > -1){
        direction = 1
      }
      this.setState({ direction })
    }
  }

  render(){

    const gallery = find(this.props.pages, {url: `/${this.props.params.type}`})
    const category = find(gallery.items, {id: this.props.params.category})

    return (
      <div
        {...merge(
          style({
            top: 0,
            left: 0,
            display: 'block',
            background: colors.nearBlack,
            width: '100%',
            minHeight: '100vh',
            zIndex: 9,
            color: colors.white
          }),
          media('(min-width: 800px)', {
          })
      )}
      >
      <div
        {...style({
          top: 0,
          left: 0,
          padding: '1.5rem',
          width: '80%',
          // display: 'none',
          zIndex: 9,
          // marginBottom: '4rem'
        })}
      >
        <Label color={colors.yellow}>
          {category.title}
        </Label>
      </div>

          <div
            {...style({
              position: 'relative',
              width: '100%',
              // minHeight: '100vh',
            })}
          >

          <div
            onClick={()=>{window.history.back()}}
            {...merge(
              style({
                cursor: 'pointer',
                position: 'fixed',
                top:0,
                padding: '1rem',
                right: 0,
                zIndex: 9,
              }),
              media('(min-width: 800px)', {
                padding: '2rem'
              }),
              media('(min-width: 1000px)', {
                padding: '4rem'
              })
            )}
          >
            <ButtonCircle
              size={40}
              color={colors.nearBlack}
              backgroundColor={colors.yellow}
            >
              <Arrow left style={{display: 'block'}}strokeWidth={2}/>
            </ButtonCircle>
          </div>

          <Match
            direction={() => this.state.direction}
            exactly pattern={`${this.props.pathname}`}
            render={(matchProps) => (
              <div
                {...merge(
                  style({

                    padding: '1.5rem',
                    width: '100%',
                    zIndex: 9,
                    color: colors.white
                  }),
                  media('(min-width: 800px)', {
                    padding: '4rem',
                  })
                )}
              >
                <ProjectList
                  pathname={`/${this.props.params.type}/${this.props.params.category}`}
                  items={category.items}
                />
              </div>
            )}
          />

          <div
            {...style({
              position: 'relative',
              width: '100%',
              // minHeight: '100vh',
              // background: colors.black
            })}
          >

          <Match
            style={{
              width: '100%'
            }}
            direction={() => this.state.direction}
            exactly pattern={`/:type/:category/:id`}
            render={(matchProps) => (
              <Project
                pages={this.props.pages}
                {...matchProps}
              />
            )}
          />

          </div>

          </div>

      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Category.js
 **/